import React from 'react';
import { useTranslation } from "react-i18next";
import BackContainer from './components/backContainer';
import TicketHeader from './components/header';
import UrlContainer from './components/urlContainer';
import ResaleBreakdown from './components/resaleBreakdown';
import Message  from './components/message';
import EditResale from './edit';
import './resale.css';


export default function ResaleMenu({onSubmit = () => {}, config}) {
    const { t } = useTranslation();
    const { id: attendeeId } = config['resale-menu'].header;
    const message = config['resale-menu'].message
    const [state, setState] = React.useState({'price': config['resale-menu'].resale_breakdown.price.value, 'is_private_resale': Boolean(config['resale-menu'].is_private_resale)});
    const [editResale, setEditResale] = React.useState(false);

    const goToTicket = React.useCallback(() => {
        onSubmit({
            data: {
                action: 'TicketMenuStep',
                payload: {
                    attendee_id: attendeeId
                }
            }
        })
    }, [onSubmit, attendeeId]);

    const performBackAction = React.useCallback(() => {
        onSubmit({
            data: {
                action: message.back_action,
            }
        })
    }, [onSubmit, message]);

    return (
        <div className='resale-container'>
            {
                !editResale ? (
                    <>
                        <BackContainer title={t('widget.resale.back-title')} onClick={goToTicket}/>
                        {message && <Message 
                            type='success'
                            title={message.title} 
                            description={message.body}
                            link={{
                                label: message.button,
                                onClick: performBackAction
                            }}
                        />}
                        <TicketHeader data={config['resale-menu'].header} state={state}/>
                        {config['resale-menu'].resale_option.url &&  <UrlContainer data={config['resale-menu']} state={state} onSubmit={onSubmit}/>}
                        <ResaleBreakdown data={config['resale-menu']} state={state} setState={setState} mode='resale-menu' goToTicket={goToTicket} setEditResale={setEditResale} onSubmit={onSubmit} />
                    </>
                ) : <EditResale/>
            }
        </div>
    )
}